export const topBarTypes = [
  'subheaderS',
  'subheaderL',
  'subheaderFlex',
  'subheaderSearchResults',
] as const;

export type TopBarType = (typeof topBarTypes)[number];
